
    import { Component, Emit, Prop, Vue, Watch } from 'nuxt-property-decorator';

    interface IValue {
        value: string;
        text: string;
        selected?: boolean;
    }

    @Component
    export default class OptionsFieldsSelect extends Vue {
        @Prop() value: string | [];
        @Prop(Array) values: IValue[];
        @Prop({ default: false }) multiple!: boolean;
        @Prop() option;
        selected: string | IValue[] = this.multiple ? [] : '';

        @Emit('input')
        onChange(val) {
            return val;
        }

        getSelectedValues() {
            if (this.value) {
                return this.value;
            }

            const selectedValues = this.values.filter((val: IValue) => val.selected);

            if (selectedValues.length > 0) {
                return this.multiple ? selectedValues : selectedValues[0].value;
            }

            return this.multiple ? [] : '';
        }

        @Watch('value', { immediate: true, deep: true })
        updateSelected() {
            this.selected = this.getSelectedValues();
        }
    }
